'use client'

import { useSearchParams } from 'next/navigation'

import { FansLeaderboardEmptyState } from '@/features/fans-leaderboard'
import { FansBoard } from '@/features/fans-leaderboard/components/FansBoard'
import {
  isLeaderboardSportTabValue,
  resolveLeaderboardSportApiValue
} from '@/features/leaderboard/buildLeaderboardSportTabs'
import { LeaderboardLoading } from '@/features/leaderboard/components/LeaderboardBoard'
import { SportFilter } from '@/features/leaderboard/components/SportFilter'
import {
  buildLeaderboardPath,
  readLeaderboardSportFromUrl
} from '@/features/leaderboard/leaderboardUrl'
import { useSportTypes } from '@/features/sport-types/hooks'
import { useRouter } from '@/i18n/routing'

import S from './GlobalFansLeaderboard.module.scss'

const GlobalFansLeaderboard = () => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const { data: sportTypes = [], isLoading: isSportTypesLoading } =
    useSportTypes()

  const sportFromUrl = readLeaderboardSportFromUrl(searchParams.get('sport'))
  const sport = isLeaderboardSportTabValue(sportFromUrl, sportTypes)
    ? sportFromUrl
    : 'all'

  const setSport = (next: string) =>
    router.replace(buildLeaderboardPath({ audience: 'fans', sport: next }), {
      scroll: false
    })

  return (
    <div className={S.root}>
      <div className={S.toolbar}>
        <SportFilter
          value={sport}
          onChange={setSport}
          sportTypes={sportTypes}
        />
      </div>

      {isSportTypesLoading && sportFromUrl !== 'all' ? (
        <LeaderboardLoading />
      ) : (
        <FansBoard
          sportType={resolveLeaderboardSportApiValue(sport)}
          emptyState={
            <FansLeaderboardEmptyState
              namespace="fansLeaderboard"
              isFiltered={sport !== 'all'}
              onClearFilter={() => setSport('all')}
            />
          }
        />
      )}
    </div>
  )
}

export default GlobalFansLeaderboard
